var _feMorphology, _feOffset, _feGaussianBlur, _feComposite, _feColorMatrix, _feMorphology2, _feOffset2, _feGaussianBlur2, _feComposite2, _feColorMatrix2, _feMorphology3, _feOffset3, _feGaussianBlur3, _feComposite3, _feColorMatrix3, _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import { useUniqueInlineId } from '@inline-svg-unique-id/react';
import * as React from "react";

function SvgAiButtonSpeechOn(props) {
  var _id6 = useUniqueInlineId();

  var _id5 = useUniqueInlineId();

  var _id4 = useUniqueInlineId();

  var _id3 = useUniqueInlineId();

  var _id2 = useUniqueInlineId();

  var _id = useUniqueInlineId();

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-45.6%",
    y: "-35.2%",
    width: "191.3%",
    height: "170.4%",
    filterUnits: "objectBoundingBox",
    id: _id
  }, _feMorphology || (_feMorphology = /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2,
    operator: "dilate",
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  })), _feOffset || (_feOffset = /*#__PURE__*/React.createElement("feOffset", {
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  })), _feGaussianBlur || (_feGaussianBlur = /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  })), _feComposite || (_feComposite = /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowBlurOuter1",
    in2: "SourceAlpha",
    operator: "out",
    result: "shadowBlurOuter1"
  })), _feColorMatrix || (_feColorMatrix = /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.11372549 0 0 0 0 0.611764706 0 0 0 0 0.91372549 0 0 0 0.69 0",
    in: "shadowBlurOuter1"
  }))), /*#__PURE__*/React.createElement("filter", {
    x: "-129.1%",
    y: "-129.1%",
    width: "358.3%",
    height: "358.3%",
    filterUnits: "objectBoundingBox",
    id: _id2
  }, _feMorphology2 || (_feMorphology2 = /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2,
    operator: "dilate",
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  })), _feOffset2 || (_feOffset2 = /*#__PURE__*/React.createElement("feOffset", {
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  })), _feGaussianBlur2 || (_feGaussianBlur2 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  })), _feComposite2 || (_feComposite2 = /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowBlurOuter1",
    in2: "SourceAlpha",
    operator: "out",
    result: "shadowBlurOuter1"
  })), _feColorMatrix2 || (_feColorMatrix2 = /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.11372549 0 0 0 0 0.611764706 0 0 0 0 0.91372549 0 0 0 0.69 0",
    in: "shadowBlurOuter1"
  }))), /*#__PURE__*/React.createElement("filter", {
    x: "-129.1%",
    y: "-129.1%",
    width: "358.3%",
    height: "358.3%",
    filterUnits: "objectBoundingBox",
    id: _id3
  }, _feMorphology3 || (_feMorphology3 = /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2,
    operator: "dilate",
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  })), _feOffset3 || (_feOffset3 = /*#__PURE__*/React.createElement("feOffset", {
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  })), _feGaussianBlur3 || (_feGaussianBlur3 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  })), _feComposite3 || (_feComposite3 = /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowBlurOuter1",
    in2: "SourceAlpha",
    operator: "out",
    result: "shadowBlurOuter1"
  })), _feColorMatrix3 || (_feColorMatrix3 = /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.11372549 0 0 0 0 0.611764706 0 0 0 0 0.91372549 0 0 0 0.69 0",
    in: "shadowBlurOuter1"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M20 12.954l1.91.002c-.008 5.9-4.666 10.706-10.5 10.945l-.001 2.599h2.546v1.91h-7V26.5h2.544v-2.686a10.966 10.966 0 01-9.495-10.57L0 12.956l1.91-.002C1.917 17.952 5.964 22 10.955 22c4.901 0 8.894-3.905 9.04-8.78l.005-.266zM12.255 0a4.655 4.655 0 014.655 4.655v9.6a4.655 4.655 0 01-4.655 4.655h-2.6A4.655 4.655 0 015 14.255v-9.6A4.655 4.655 0 019.655 0zm0 1.91h-2.6A2.745 2.745 0 006.91 4.655v9.6A2.745 2.745 0 009.655 17h2.6A2.745 2.745 0 0015 14.255v-9.6a2.745 2.745 0 00-2.745-2.745z",
    id: _id4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.104 21.294a.54.54 0 01.285.143l1.282 1.78a.54.54 0 00.285.142c.071 0 .142-.071.142-.071.071 0 .071-.071.071-.142l.641-2.137c0-.142.071-.213.214-.213l2.136-.641c.071 0 .142-.143.214-.214 0-.07 0-.213-.143-.285l-1.78-1.281c-.071-.071-.142-.143-.142-.285v-2.207c0-.072-.071-.214-.143-.214-.142-.071-.213-.071-.285 0l-1.78 1.353a.217.217 0 01-.284 0l-2.137-.712c-.07 0-.213 0-.284.071-.072.071-.072.214-.072.285l.712 2.136c.072.071 0 .214-.07.285l-1.283 1.78a.217.217 0 000 .285c.072.071.143.142.214.142h2.207z",
    id: _id5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.104 27.294a.54.54 0 01.285.143l1.282 1.78a.54.54 0 00.285.142c.071 0 .142-.071.142-.071.071 0 .071-.071.071-.142l.641-2.137c0-.142.071-.213.214-.213l2.136-.641c.071 0 .142-.143.214-.214 0-.07 0-.213-.143-.285l-1.78-1.281c-.071-.071-.142-.143-.142-.285v-2.207c0-.072-.071-.214-.143-.214-.142-.071-.213-.071-.285 0l-1.78 1.353a.217.217 0 01-.284 0L7.68 22.31c-.07 0-.213 0-.284.071-.072.071-.072.214-.072.285l.712 2.136c.072.071 0 .214-.07.285l-1.283 1.78a.217.217 0 000 .285c.072.071.143.142.214.142h2.207z",
    id: _id6
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(14 16)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#".concat(_id, ")"),
    xlinkHref: "#".concat(_id4)
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#1D9CE9",
    d: "M2.429 12.37a8.545 8.545 0 002.488 6.628 8.512 8.512 0 006.038 2.502 8.51 8.51 0 005.948-2.413 8.54 8.54 0 002.596-6.302h0l2.898-.4a11.443 11.443 0 01-3.18 8.5 11.417 11.417 0 01-7.307 3.486h0V26h2.545v2.91h-8V26h2.544v-1.757a11.434 11.434 0 01-6.564-3.635 11.435 11.435 0 01-2.934-7.794h0zM12.255-.5c1.38 0 2.635.543 3.56 1.427a5.141 5.141 0 011.571 3.23l.02.274.004 9.824c0 1.38-.543 2.635-1.427 3.56a5.141 5.141 0 01-3.23 1.571l-.274.02-2.824.004a5.138 5.138 0 01-3.56-1.427 5.141 5.141 0 01-1.571-3.23l-.02-.274L4.5 4.655c0-1.38.543-2.635 1.427-3.56a5.141 5.141 0 013.23-1.571l.274-.02L12.255-.5zm0 2.91h-2.6l-.198.009c-.52.045-.99.271-1.347.628-.402.402-.66.967-.7 1.623h0v9.585l.009.198c.045.52.271.99.628 1.347.402.402.967.66 1.623.7h2.585l.198-.009c.52-.045.99-.271 1.347-.628.402-.402.66-.967.7-1.623h0V4.655l-.007-.184a2.238 2.238 0 00-.65-1.403 2.238 2.238 0 00-1.588-.658h0z",
    fill: "#EDF8FF",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#".concat(_id2, ")"),
    xlinkHref: "#".concat(_id5)
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#1D9CE9",
    d: "M39.561 15.284l1.248 2.732 1.689 1.216c.024 1.337-.189 1.423-.338 1.423h0l-1.899.592-.594 1.979c-.866.633-1.19.504-1.35.344h0l-1.286-1.776h-2.134c-.171 0-.378-.1-.567-.289a.709.709 0 01-.2-.496h0l1.393-2.165-.694-2.082c-.005-.267.053-.575.213-.735.16-.16.467-.217.638-.217h0l2.198.705 1.683-1.231z",
    fill: "#EDF8FF",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#".concat(_id3, ")"),
    xlinkHref: "#".concat(_id6)
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#1D9CE9",
    d: "M11.561 21.284l1.248 2.732 1.689 1.216c.024 1.337-.189 1.423-.338 1.423h0l-1.899.592-.594 1.979c-.866.633-1.19.504-1.35.344h0l-1.286-1.776H6.897c-.171 0-.378-.1-.567-.289a.709.709 0 01-.2-.496h0l1.393-2.165-.694-2.082c-.005-.267.053-.575.213-.735.16-.16.467-.217.638-.217h0l2.198.705 1.683-1.231z",
    fill: "#EDF8FF",
    fillRule: "evenodd"
  })))));
}

export default SvgAiButtonSpeechOn;